import Vue from 'vue'
import Antd, { Popconfirm } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'xe-utils'
import 'vxe-table/lib/style.css'
import 'vxe-pc-ui/lib/style.css'
import './assets/styles/index.css'
import App from './App.vue'
import VXETable from 'vxe-table'
import VXEPcUi from 'vxe-pc-ui'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(VXETable)
Vue.use(VXEPcUi)

// 全局设置 Popconfirm 默认按钮文案为中文
Vue.component(Popconfirm.name, {
  ...Popconfirm,
  props: {
    ...Popconfirm.props,
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  }
})

new Vue({
  render: h => h(App)
}).$mount('#app')
